import { MapPin, Mail, Clock, Instagram, Facebook, Youtube } from "lucide-react";

export default function Contact() {
    return (
        <section
            id="contact"
            className="section-py container-px relative overflow-hidden"
            data-testid="contact-section"
        >
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-7">
                    <p className="overline">Visit us</p>
                    <h2 className="mt-6 font-serif text-5xl sm:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95]">
                        Come and <em className="italic text-[hsl(var(--primary))]">linger.</em>
                    </h2>
                    <p className="mt-10 max-w-xl text-muted-foreground text-lg font-light leading-relaxed">
                        Thirty minutes west of Austin, just off the Pedernales — drop by for
                        an afternoon in the gallery, a coffee in the courtyard, or to plan
                        your evening with us.
                    </p>

                    <div className="mt-12 grid sm:grid-cols-2 gap-8 max-w-xl">
                        <Info icon={MapPin} title="Address">
                            12649 TX-71
                            <br />
                            Spicewood, TX 78669
                        </Info>
                        <Info icon={Mail} title="Email">
                            <a
                                href="mailto:gallery@lopezhill.com"
                                className="hover:text-[hsl(var(--primary))] transition-colors"
                                data-testid="contact-email"
                            >
                                gallery@lopezhill.com
                            </a>
                        </Info>
                        <Info icon={Clock} title="Hours">
                            Thu–Fri · 10am–6pm
                            <br />
                            Sat · 11am–6pm
                            <br />
                            Mon–Wed · by appointment
                        </Info>
                        <Info icon={Instagram} title="Social">
                            <div className="flex gap-4 mt-1">
                                <a href="https://www.instagram.com/lopezhilltx/" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="social-instagram">
                                    <Instagram className="h-5 w-5 hover:text-[hsl(var(--primary))] transition-colors" strokeWidth={1.2} />
                                </a>
                                <a href="https://www.facebook.com/Lopez-Hill-106663192017748" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="social-facebook">
                                    <Facebook className="h-5 w-5 hover:text-[hsl(var(--primary))] transition-colors" strokeWidth={1.2} />
                                </a>
                                <a href="https://www.youtube.com/channel/UCfMgi-PrM8Ojfgg9jLND2lw" target="_blank" rel="noreferrer" aria-label="Youtube" data-testid="social-youtube">
                                    <Youtube className="h-5 w-5 hover:text-[hsl(var(--primary))] transition-colors" strokeWidth={1.2} />
                                </a>
                            </div>
                        </Info>
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <a
                        href="https://maps.app.goo.gl/3GAiogYCEAe27Hii7"
                        target="_blank"
                        rel="noreferrer"
                        className="block relative w-full h-[420px] lg:h-[560px] overflow-hidden border border-border group"
                        aria-label="Open López Hill location in Google Maps"
                        data-testid="contact-map-link"
                    >
                        <iframe
                            title="López Hill on Google Maps"
                            src="https://www.google.com/maps?q=12649+TX-71,+Spicewood,+TX+78669&output=embed"
                            className="absolute inset-0 w-full h-full grayscale-[0.4] contrast-[0.95] pointer-events-none"
                            loading="lazy"
                        />
                        <span className="absolute bottom-3 right-3 bg-background/90 backdrop-blur px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-foreground border border-border">
                            Open in Maps
                        </span>
                    </a>
                </div>
            </div>
        </section>
    );
}

function Info({ icon: Icon, title, children }) {
    return (
        <div className="flex gap-4">
            <Icon className="h-5 w-5 text-[hsl(var(--primary))] mt-1" strokeWidth={1.2} />
            <div>
                <div className="overline">{title}</div>
                <div className="mt-2 text-base font-light text-foreground leading-relaxed">
                    {children}
                </div>
            </div>
        </div>
    );
}
